import { TriangleAlert } from "lucide-react";

export const CapsLockWarning = ({ visible }: { visible: boolean }) =>
  visible ? (
    <p className="flex items-center gap-1.5 text-amber-600 text-[0.75rem] -mt-1 mb-2">
      <TriangleAlert size={13} strokeWidth={2} />
      Caps Lock is on
    </p>
  ) : null;
